import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbContactUsTopic, EbContactUsTopics } from '../interfaces/eb-contact-form.interface'

@Injectable({
  providedIn: 'root'
})
export class EbContactUsTopicsNormalizer implements Converter<any, EbContactUsTopics> {
  convert(source: any, target?: EbContactUsTopics): EbContactUsTopics {
    if (!source) {
      return [] as EbContactUsTopics
    }

    if (target === undefined) {
      target = [] as EbContactUsTopics
    }
    source.items.forEach((item: EbContactUsTopic) => {
      target.push(item)
    })
    return target
  }
}
